import { render } from "./BeritaTerkini.vue?vue&type=template&id=0907e972"
import script from "./BeritaTerkini.vue?vue&type=script&lang=js"
export * from "./BeritaTerkini.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__